import { useTranslation } from 'react-i18next';

import { useDashboardInformation } from '../../../../TemporaryConmonents/DashboardInformation/useDashboardInformation';

export const usePresentationModal = (onClosePresentation: () => void, tariffQuery: string) => {
    const { t } = useTranslation();
    const { is_owner } = useDashboardInformation();
    const hideModal = () => {
        onClosePresentation?.();
    };

    const changeTariff = async () => {
        hideModal();
        // @ts-ignore
        const url = `${routable.getRoute('openChangeTariff')}${tariffQuery}`;
        // @ts-ignore
        if (is_owner) {
            // @ts-ignore
            $.modalable('open', {
                url,
            });
        } else {
            // @ts-ignore
            $.modalable('open', {
                content: `<div>${t('useDashboard.return.changeTariff.content')}</div>`,
            });
        }
    };
    return { hideModal, changeTariff, t };
};
